import React from 'react';
import MaskedInput from 'react-text-mask';

const mask = () => {
  return [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/];
};

const PostalCodeInput = ({ inputRef, ...other }) => {
  return (
    <MaskedInput
      ref={ref => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={mask}
      placeholderChar={'\u2000'}
      showMask={false}
      {...other}
    />
  );
};

export default PostalCodeInput;
